export const SHOW = `@LOADER/SHOW`;
export const HIDE = `@LOADER/HIDE`;

export const showLoader = () => ({ type: SHOW });
export const hideLoader = () => ({ type: HIDE });
